/* Customer video rails. External asset on purpose — the theme editor re-injects section HTML
   without running scripts inside it, so all wiring is delegated from here.
   No native controls anywhere: the poster, the play button and the large player are the UI. */
(function () {
  function videos() { return document.querySelectorAll('.reel__v[data-reel-v]'); }

  function stopOthers(keep) {
    videos().forEach(function (v) {
      if (v === keep) return;
      if (!v.paused) v.pause();
      var c = v.closest('.reel');
      if (c) c.classList.remove('is-playing');
    });
  }

  function play(v) {
    v.muted = false;
    var p = v.play();
    /* Autoplay policy can still refuse sound on some browsers — fall back rather than fail silently */
    if (p && p.catch) { p.catch(function () { v.muted = true; v.play(); }); }
  }

  function toggleInline(reel) {
    var v = reel.querySelector('[data-reel-v]');
    if (!v) return;
    if (v.paused) { stopOthers(v); play(v); reel.classList.add('is-playing'); }
    else { v.pause(); reel.classList.remove('is-playing'); }
  }

  /* ── Large player ─────────────────────────────────────────────────────────── */
  var box = null, current = null, home = null, homeNext = null;

  function ensureBox() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'pm-reelbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<button type="button" class="pm-reelbox__btn pm-reelbox__close" data-rb-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="pm-reelbox__btn pm-reelbox__prev" data-rb-nav="prev" aria-label="Previous">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="pm-reelbox__btn pm-reelbox__next" data-rb-nav="next" aria-label="Next">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="pm-reelbox__stage" data-rb-stage>' +
        '<span class="pm-reelbox__hint" data-rb-hint aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor"><path d="M8 5.5v13l11-6.5-11-6.5z"/></svg></span>' +
        '<p class="pm-reelbox__cap" data-rb-cap></p>' +
      '</div>';
    document.body.appendChild(box);
    return box;
  }

  function siblings(reel) {
    var wrap = reel.parentElement;
    while (wrap && !wrap.matches('.reel-row, .reel-circles')) { wrap = wrap.parentElement; }
    if (!wrap) return [reel];
    return Array.prototype.filter.call(wrap.querySelectorAll('.reel'), function (r) {
      return r.querySelector('[data-reel-v]');
    });
  }

  function restore() {
    var stage = box && box.querySelector('[data-rb-stage]');
    var v = stage && stage.querySelector('[data-reel-v]');
    if (!v) return;
    v.pause();
    v.currentTime = 0;
    /* The editor may have re-rendered the section while the player was open, leaving the
       original slot detached — putting the node back would throw and kill the handler. */
    try {
      if (home && home.isConnected) { home.insertBefore(v, homeNext && homeNext.isConnected ? homeNext : null); }
      else { v.remove(); }
    } catch (err) { v.remove(); }
    home = homeNext = null;
  }

  function show(reel) {
    ensureBox();
    var v = reel.querySelector('[data-reel-v]');
    if (!v) return;
    restore();
    current = reel;
    home = v.parentElement;
    homeNext = v.nextSibling;
    var stage = box.querySelector('[data-rb-stage]');
    stage.insertBefore(v, stage.firstChild);
    var cap = box.querySelector('[data-rb-cap]');
    var text = reel.querySelector('.reel__cap');
    cap.textContent = text ? text.textContent.trim() : '';
    cap.style.display = cap.textContent ? '' : 'none';
    var many = siblings(reel).length > 1;
    box.querySelector('.pm-reelbox__prev').style.display = many ? '' : 'none';
    box.querySelector('.pm-reelbox__next').style.display = many ? '' : 'none';
    stopOthers(v);
    box.classList.add('is-open');
    window.pmScrollLock && pmScrollLock.lock();
    play(v);
    syncHint();
  }

  function syncHint() {
    if (!box) return;
    var v = box.querySelector('[data-rb-stage] [data-reel-v]');
    var hint = box.querySelector('[data-rb-hint]');
    if (hint) hint.style.opacity = (v && v.paused) ? '1' : '0';
  }

  function close() {
    if (!box) return;
    restore();
    box.classList.remove('is-open');
    window.pmScrollLock && pmScrollLock.unlock();
    current = null;
  }

  function step(dir) {
    if (!current) return;
    var list = siblings(current);
    var i = list.indexOf(current);
    if (i < 0) return;
    var next = list[(i + (dir === 'prev' ? -1 : 1) + list.length) % list.length];
    if (next && next !== current) show(next);
  }

  /* ── Delegated events — survive any editor re-render ──────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-rb-close]')) { close(); return; }
    var nav = t.closest('[data-rb-nav]');
    if (nav) { step(nav.getAttribute('data-rb-nav')); return; }
    if (box && box.classList.contains('is-open')) {
      var stage = t.closest('[data-rb-stage]');
      if (stage) {
        var v = stage.querySelector('[data-reel-v]');
        if (v) { v.paused ? play(v) : v.pause(); syncHint(); }
        return;
      }
      if (t.closest('.pm-reelbox')) { close(); return; }
    }

    var open = t.closest('[data-reel-open]');
    if (open) { show(open.closest('.reel')); return; }
    var btn = t.closest('[data-reel-play]');
    if (btn) { toggleInline(btn.closest('.reel')); return; }

    var railNav = t.closest('[data-reel-nav]');
    if (railNav) {
      var rail = railNav.closest('.reel-rail');
      var row = rail && rail.querySelector('.reel-row');
      if (!row) return;
      var card = row.querySelector('.reel');
      var amount = card ? card.offsetWidth + 14 : row.clientWidth * 0.8;
      row.scrollBy({ left: railNav.getAttribute('data-reel-nav') === 'prev' ? -amount : amount, behavior: 'smooth' });
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step('prev');
    else if (e.key === 'ArrowRight') step('next');
  });

  /* Pause a clip once it scrolls away, so audio never follows the shopper down the page */
  var watched = new WeakSet();
  function watch(v) {
    if (watched.has(v) || !('IntersectionObserver' in window)) return;
    watched.add(v);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting || en.target.paused) return;
        if (box && box.contains(en.target)) return;   /* the large player is its own context */
        en.target.pause();
        var c = en.target.closest('.reel');
        if (c) c.classList.remove('is-playing');
      });
    }, { threshold: 0.25 }).observe(v);
  }

  function syncRail(rail) {
    var row = rail.querySelector('.reel-row');
    if (!row) return;
    rail.classList.toggle('has-overflow', row.scrollWidth - row.clientWidth > 8);
    var prev = rail.querySelector('[data-reel-nav="prev"]');
    var next = rail.querySelector('[data-reel-nav="next"]');
    if (prev) prev.disabled = row.scrollLeft < 8;
    if (next) next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 8;
  }

  function scan() {
    videos().forEach(watch);
    if (box && box.classList.contains('is-open')) return;
    document.querySelectorAll('.reel-rail').forEach(function (rail) {
      syncRail(rail);
      if (rail.dataset.reelBound) return;
      rail.dataset.reelBound = '1';
      var row = rail.querySelector('.reel-row');
      if (row) row.addEventListener('scroll', function () { syncRail(rail); }, { passive: true });
    });
  }

  var queued = false;
  function scanSoon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }
  document.addEventListener('shopify:section:load', scanSoon);
  window.addEventListener('resize', scanSoon);
  if ('MutationObserver' in window) {
    new MutationObserver(scanSoon).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
